import {IGameRunnerProxy} from "../../../../common/interfaces/game-runner-proxy.interface";
import BaseService from "../../base/base_service";
import {UndefinedString} from "../../../../common/types/nullable-types";
import {OpenGameParameters} from "../../../../app-react/services/games/game-info";


interface GameRunnerProxyServiceParams {
    getGameRunnerService: () => Promise<IGameRunnerProxy>;
}

export default class GameRunnerProxyService extends BaseService implements IGameRunnerProxy {
    static CLASS = 'GameRunnerProxyService';

    private _params: GameRunnerProxyServiceParams;
    init(params: GameRunnerProxyServiceParams) {
        this._params = params;
    }


    private _getGameRunner(): Promise<IGameRunnerProxy> {
        return this._params.getGameRunnerService();
    }

    get isGameRunningLegacy(): Promise<boolean> {
        return this._getGameRunner().then(r => r.isGameRunningLegacy);
    }

    async closeRunningGame(): Promise<void> {
        await (await this._getGameRunner()).closeRunningGame();
    }

    get isGameRunningInFreePlayModeLegacy(): Promise<boolean> {
        return this._getGameRunner().then(r => r.isGameRunningInFreePlayModeLegacy);
    }

    get currentRunningGameCompanyNameLegacy(): Promise<UndefinedString> {
        return this._getGameRunner().then(r => r.currentRunningGameCompanyNameLegacy);
    }

    async continuePlayCurrentGameLegacy(): Promise<void> {
        await (await this._getGameRunner()).continuePlayCurrentGameLegacy();
    }

    async stopCurrentGameAutoplayLegacy(): Promise<void> {
        await (await this._getGameRunner()).stopCurrentGameAutoplayLegacy();
    }

    async shouldShowRealityCheckMessageWhileGameIsOpenLegacy(): Promise<boolean> {
        return await (await this._getGameRunner()).shouldShowRealityCheckMessageWhileGameIsOpenLegacy();
    }

    async shouldShowTimeLimitMessageWhileGameIsOpenLegacy(): Promise<boolean> {
        return await (await this._getGameRunner()).shouldShowTimeLimitMessageWhileGameIsOpenLegacy();
    }

    get isOpenGameInProgress(): Promise<boolean> {
        return this._getGameRunner().then(r => r.isOpenGameInProgress);
    }

    async openRealGameFromSdkRequest(gameType: number, options?: OpenGameParameters): Promise<void> {
        await (await this._getGameRunner()).openRealGameFromSdkRequest(gameType);
    }

    async openDemoGameFromSdkRequest(gameType: number, options?: OpenGameParameters): Promise<void> {
        await (await this._getGameRunner()).openDemoGameFromSdkRequest(gameType, options);
    }
}